var app = app ||  {};
app.datatable = app.datatable || {};

;(function(namespace, $){

  var data_table = [],
      img = false;

  function init(refresh_status, flag, filter_data, table_id, uri) {

      var targets,
          not_ordenable,
          column_classes,
          data_class;

      targets = [];
      not_ordenable = [];
      column_classes = [];

      $('#' + table_id + '-table th').each(function(index, el) {
          data_class = $(this).attr('data-class');
          targets.push(index);
          column_classes.push(data_class);
      });
      
      DataTable(table_id, uri, filter_data, refresh_status, flag, targets, not_ordenable, column_classes);
  }

  // inicializa datatable
  // el_id = id do form ou elemento
  // data_url = url que sera feita a requisicao ajax
  // data = parametros da consulta
  // refresh_status(bool)
  // flag(bool)
  function DataTable(el_id, data_url, data, refresh_status, flag, targets, not_ordenable, column_classes) {
    console.log(table_id);

      var table_id = $('#' + el_id + '-table').attr('id'),
          table_row = el_id + '-row',
          table_col = el_id + '-col';
      
      $(document).ready( function () {

        if(flag) {
          data_table['"' + el_id + '"'] = $('#' + table_id).DataTable({
            "pageLength": 10,
            "lengthMenu": [5, 10, 30],
            "bFilter": false,
            "order": [],
            "columnDefs": [
              {"targets": targets,
                "createdCell": function (td, cellData, rowData, row, col) {

                    for (var i = 0; i < column_classes.length; i++) {
                      if(col == i && typeof column_classes[i] !== 'undefined') {
                        $(td).addClass(column_classes[i] + ' ' + table_col);
                      }
                    }

                  if($(td).hasClass('action') || $(td).hasClass('marcador')) {
                    $(td).addClass('text-right');
                  }

                  if($(td).find('a').hasClass('action') || $(td).hasClass('check') || $(td).hasClass('sel') || $(td).hasClass('codigo')) {
                    $(td).removeClass(table_col);
                  }
                }
              },
              { targets: not_ordenable, orderable: false }
            ],
            "processing": true,
            "serverSide": true,
            deferRender: true,
            responsive: true,
            "ajax": {
              headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
              },
              type: 'POST',
              "url": url + data_url,
              "dataSrc": function(json) {
                return json.data;
              }
            },
            // rowId: 1,
            "rowCallback": function( row, data ) {

              if( typeof selected != 'undefined') {
                if ( $.inArray(data[1], selected) !== -1 ) {
                  //$(row).addClass('selected');
                  $(row).find('.check-notas').prop('checked', 'checked');
                }
              }
              
            },
            "createdRow": function( row, data, dataIndex ) {
                $(row).addClass( table_row );
            },
            language: {
                paginate: {
                  first:    '«',
                  previous: '‹',
                  next:     '›',
                  last:     '»'
                },
                aria: {
                  paginate: {
                      first:    'Primeira',
                      previous: 'Anterior',
                      next:     'Próxima',
                      last:     'ùltima'
                  }
                },
              "search": "Buscar:",
              "sProcessing": '<img src="' + loading_img + '" alt=""> Carregando...',
              searchPlaceholder: "buscar...",
              "info": "Mostrando _START_ a _END_ de _TOTAL_ resultados",
              "lengthMenu": "Exibir _MENU_ resultados",
              "zeroRecords": "Nenhum resultado",
              "infoEmpty": "",
              "infoFiltered": ""
            },
          });
        }

        if(refresh_status) {
          data_table['"' + el_id + '"'].ajax.url( url + data_url + data ).load();
        }
      });
    }

    namespace.initDataTable = init;

})(app.datatable, jQuery);

